var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.614 46.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#702180;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essay_from_outline",
    "data-name": "Essay from outline"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.307,
    cy: 23.307,
    r: 23.307
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.971,32.5a3.7,3.7,0,0,1-3.855-3.846,44.133,44.133,0,0,1-.132-4.571,44.917,44.917,0,0,1,.13-4.568,3.688,3.688,0,0,1,3.845-3.849,44.7,44.7,0,0,1,4.571-.129h.023a.777.777,0,1,1-.023,1.554c-1.938,0-3.381.005-4.4.12a2.216,2.216,0,0,0-2.476,2.478c-.115,1.016-.119,2.458-.119,4.394s.007,3.378.123,4.393a2.227,2.227,0,0,0,2.486,2.48c1.015.115,2.454.119,4.385.119s3.371,0,4.385-.121A2.23,2.23,0,0,0,29.4,28.469c.116-1.015.122-2.456.122-4.388v-.022a.777.777,0,0,1,1.554.022,43.99,43.99,0,0,1-.133,4.564,3.7,3.7,0,0,1-3.854,3.85,43.964,43.964,0,0,1-4.563.135H22.3a41.638,41.638,0,0,1-4.326-.129Zm3.782-6.863a.777.777,0,0,1-.777-.777V22.53a.779.779,0,0,1,.227-.549l9.323-9.323a.778.778,0,0,1,1.1,0l2.33,2.331a.775.775,0,0,1,0,1.1L24.633,25.41a.776.776,0,0,1-.549.228Zm.777-2.786v1.232h1.232l6.216-6.215-1.232-1.232Zm7.314-7.314,1.232,1.232,1.232-1.232-1.232-1.232Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.48962a1dde1d664e24adc60b1c784213.svg";
export { ForwardRef as ReactComponent };